import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadZoneListFailed,
  loadZoneListSuccessful,
  loadZoneListBegin,
} from '../actions';
import { mapParkingLotsToZones } from './mapParkingLotsToZones';

export default function* loadZoneList(action) {
  try {
    const url = `${BACKEND_URL}/proxy/parking-registration/v1/parking_lots`;
    yield put(loadZoneListBegin());
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      const zones = mapParkingLotsToZones(data?.data || []);
      data.data = zones;
      data.result = zones;
      yield put(loadZoneListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadZoneListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadZoneListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
